export default "__VITE_ASSET__DA$p8sOz__"